import React, { useCallback, useEffect } from 'react';

import { setHelloBarCount } from 'actions/hellobar';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectEngagementHelloBar } from 'selectors/hellobar';

import { EngagementIconDualTone, EngagementIconHover, EngagementIconSelected } from 'assets/assetsV1/iconComponents';

import { HELLO_BAR_PAGE_TYPE, HELLO_BAR_PAGE_TYPE_2 } from 'constants/ProjectConstants';
import { getMatchesForCurrentRoute, goToEngagement } from 'constants/helper';

import { getHelloBarDetails } from 'services/notifications';

import { NavItem } from 'uiToolkitV1/NavBar';

import { HeaderIconContainer } from './common/styles';

const EngagementHeader = () => {
  const history = useHistory();
  const { isEngagementMatch, isAnalyticsV0Match } = getMatchesForCurrentRoute(
    history.location.pathname,
    history.location
  );
  const dispatch = useDispatch();

  const engagementHelloBar = useSelector(selectEngagementHelloBar);
  const { count: notificationCount, refresh: shouldRefresh } = engagementHelloBar;

  const getPendingEngagementCount = useCallback(() => {
    getHelloBarDetails({ pageType: HELLO_BAR_PAGE_TYPE.ENGAGEMENT })
      .then((res) => dispatch(setHelloBarCount({ param: HELLO_BAR_PAGE_TYPE_2.ENGAGEMENT, value: res.count })))
      .catch((err) => console.error(err));
  }, [dispatch]);

  useEffect(() => {
    getPendingEngagementCount();
  }, [shouldRefresh, getPendingEngagementCount]);

  return (
    <HeaderIconContainer onClick={() => goToEngagement(history)}>
      <NavItem
        Icon={EngagementIconDualTone}
        HoverIcon={EngagementIconHover}
        ActiveIcon={EngagementIconSelected}
        isActive={isEngagementMatch && !isAnalyticsV0Match}
        notificationCount={notificationCount}
      >
        Engagement
      </NavItem>
    </HeaderIconContainer>
  );
};

export default EngagementHeader;
